<template>
	<div>
		<div class="product-option" :class="{ 'is-selected': selected, 'is-disabled': disabled }" role="button" @click.prevent="toggleSelection">
			<div class="option-image"><img v-if="option.image_url" :src="option.image_url"/></div>
			<div class="option-name">{{ option.name }}</div>
		</div>	

		<div class="is-disabled-notice" v-if="disabled">
			<div v-if="requiredOptionsLabel">{{ requiredOptionsLabel }}</div>
			<div v-if="requiredSizeLabel">{{ requiredSizeLabel }}</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash/array';
import { mapState, mapActions } from 'vuex';

export default {
	props: {
		option: { type: Object, required: true },
		disabled: { type: Boolean, default: false },
	},

	computed: {
		...mapState({
			optionTypes: state => state.shell.productOptionTypes,
			cartItem: state => state.customizer.cartItem,
			options: state => state.customizer.options,
			selections: state => state.customizer.optionSelections,
		}),

		// return true if option is selected
		selected()
		{
			var current = this.selections[this.option.product_option_type_id] || [];
			return current.indexOf(this.option.id) >= 0;
		},

		requiredOptionsLabel()
		{
			var required = this.option.required_options.filter(id => this.options[id]);

			if (required.length > 0)
			{
				var names = this.option.required_options
					.filter(id => this.options[id])
					.map(id => this.options[id].name);

				names = _.uniq(names);
					
				if (names.length > 1)
					return `Requires one of ${names.join(', ')} to be selected`;
				else
					return `Requires ${names[0]} to be selected`;
			}
			else
			{
				return '';
			}
		},

		requiredSizeLabel()
		{
			var option = this.option;
			var width = parseInt(this.cartItem.width.whole, 10) || 0;
			var height = parseInt(this.cartItem.height.whole, 10) || 0;
			var restricted = (option.restrict_to_size && (width < option.min_width || width >= option.max_width || height < option.min_height || height >= option.max_height));

			return restricted ? `Size must be between ${option.min_width}-${option.max_width}" wide and ${option.min_height}-${option.max_height}" high` : '';
		}
	},

	methods: {
		...mapActions('customizer', ['selectOption', 'deselectOption', 'filterSelectableOptions']),

		// toggle the selection state of this option
		toggleSelection()
		{
			if (this.disabled)
				return;

			var params = {
				optionId: this.option.id,
				optionType: this.optionTypes[this.option.product_option_type_id],
			};

			// (de-)select option
			if (this.selected)
				this.deselectOption(params);
			else
				this.selectOption(params);

			this.filterSelectableOptions();
		}
	}
}
</script>